module.exports = {
  "agreement": {
    rechargeNotice: "充值须知",
    serviceAgreement: "用户协议",
    privacyAgreement: "隐私政策",
    childProtection: "儿童隐私保护政策",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/agreement/zh-CN.js